<template>
  <div class="layout">
    <div v-model="drawer" class="layout-drawer" :class="{'drawer-closed': drawerClosed}">
      <div class="sidebar">
        <div class="header">
          <div class="header__icon">
            {{ user.last_name.charAt(0) }}
          </div>
          <div class="header__title">{{ user.first_name }} {{ user.last_name }}</div>
        </div>
        <div class="menu">
          <q-list no-border link inset-delimiter class="menu-list">
            <q-item :to="'/users/' + $route.params.id" exact>
              <q-item-side icon="account_circle"/>
              <q-item-main label="Детали"/>
            </q-item>
            <q-item :to="'/users/' + $route.params.id + '/transactions'">
              <q-item-side icon="swap_horiz"/>
              <q-item-main label="Транзакции"/>
            </q-item>
            <q-item v-if="user.role === 'root'" :to="'/users/' + $route.params.id + '/tokens'">
              <q-item-side icon="security"/>
              <q-item-main label="Токены"/>
            </q-item>
          </q-list>
        </div>
      </div>
      <div class="drawer-handle" @click="drawerMove()">
        <div class="drawer-handle-arrow"></div>
      </div>
    </div>

    <div class="page-container">
      <div class="scroll-container">
        <router-view/>
      </div>
    </div>

  </div>
</template>

<script>
import {
  QBtn,
  QIcon,
  QItem,
  QItemMain,
  QItemSeparator,
  QItemSide,
  QItemTile,
  QLayout,
  QLayoutDrawer,
  QList,
  QListHeader,
  QPage,
  QPageContainer,
  QToolbar,
  QToolbarTitle,
} from 'quasar'

export default {
  name: 'home',
  components: {
    QLayout,
    QLayoutDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QListHeader,
    QItem,
    QItemSide,
    QItemSeparator,
    QItemMain,
    QItemTile,
  },
  data () {
    return {
      user: {
        first_name: '',
        last_name: '',
        role: '',
      },
      drawer: true,
      drawerClosed: localStorage.getItem('drawer-closed') ? JSON.parse(localStorage.getItem('drawer-closed')) : false,
    }
  },
  mounted () {
    this.fetchUser()
  },
  methods: {
    fetchUser () {
      this.$http.get(`api/v1.0/users/${ this.$route.params.id }`).then((response) => {
        this.user = response.data
        this.$store.commit('user/setUser', response.data)
      })
    },
    drawerMove () {
      this.drawerClosed = !this.drawerClosed
      this.$root.$emit('drawer-moved')
      localStorage.setItem('drawer-closed', `${ this.drawerClosed }`)
    },
  },
}
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  width: 100%;
  min-height: 100vh;
}

.q-item-side {
  color: #334759;
  text-align: center;
}

.q-item-main {
  color: #334759;
}

.sidebar {
  position: absolute;
  width: 100%;
  height: 100vh;
  background: #F4F5F7;
  display: flex;
  flex-direction: column;
}

.menu {
  flex: 1 1 auto;
}

.menu-list {
  padding: 0;
}

.logo {
  flex: 0 1 auto;
  padding: 30px 25px;

  img {
    width: 140px;
    height: auto;
  }
}

.userbar {
  position: relative;
  flex: 0 1 auto;
  margin: 20px 0;
}

.logout {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
}

.drawer-closed .logout {
  position: static;
}

.profile-link {
  color: inherit;
  text-decoration: none;
}

.header {
  display: flex;
  padding: 20px 16px;
  align-items: center;
  overflow: hidden;

  &__icon {
    display: flex;
    flex-shrink: 0;
    width: 38px;
    height: 38px;
    align-items: center;
    justify-content: center;
    color: #334759;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 700;
    background: #fff;
  }

  &__title {
    margin-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/UserView.vue